import React from 'react'
import Errors from '../errors'

const ErrorsDe = () => {
    return <Errors languageCode="de" />
}

export default ErrorsDe
